import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {stepsData} from '../../modules/tutorial'
import TooltipStep from './TooltipStep'
import wrappedIntlComponent from "../common/intl/WrappedIntlComponent"


class TutorialRoot extends Component {
    render() {
        if (!Object.values(stepsData).length) return null
        return Object.values(stepsData).map(({step, text}) => <TooltipStep key={step} step = {+step} text = {text} />)
    }

    getChildContext() {
        return {
            formatMessage: this.props.formatMessage,
        }
    }

    static childContextTypes = {
        formatMessage: PropTypes.any,
    }
}

export default wrappedIntlComponent(TutorialRoot)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/tutorial/TutorialRoot.js